import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=5656009c"
import script from "./pagination.ts?vue&type=script&lang=js&external"
export * from "./pagination.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5656009c')) {
      api.createRecord('5656009c', component.options)
    } else {
      api.reload('5656009c', component.options)
    }
    module.hot.accept("./pagination.vue?vue&type=template&id=5656009c", function () {
      api.rerender('5656009c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/child/pagination/pagination.vue"
export default component.exports